

  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {authModule, challengeModule, filesModule, filesState, i18nModule} from '@/utils/store-acessor';
  import {LocaleSelectorType} from '@/store/i18n.store.module';
  import {ChallengeModel} from '@/models/challenge.model';
  import {Emit, Watch} from 'vue-property-decorator';
  import {ChallengeFileModel, FilesEvents} from '@/models/challenge-file.model';

  @Component({})
  export default class ChallengeFiles extends Vue {
    searchParam = '';
    page = 1;
    @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
    @i18nModule.Getter('locale') localeSelected!: LocaleSelectorType;
    @filesModule.Getter('files') files!: ChallengeFileModel[];
    @filesModule.Getter('lastPage') lastPage!: number;
    @filesModule.Getter('loading') loading!: boolean;

    getHeader() {
      this.headers = [
        {
          text: this.$t('files.title'),
          align: 'left',
          sortable: false,
          value: 'title',
        },
        {
          text: this.$t('files.description'),
          align: 'left',
          sortable: false,
          value: 'description',
        },
        {
          text: this.$t('files.buttons.download'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ];
    }

    headers: any = [];

    @Watch('localeSelected')
    asyncTranslate() {
      this.getHeader();
    }

    async mounted() {
      this.getHeader();
      if (this.challenge?.id) {
        await filesState.fetchAll({
          page: 1,
          challengeId: this.challenge.id,
        });
      }
    }

    @Emit()
    onFileEvent(event: FilesEvents): FilesEvents {
      return event;
    }

    @Watch('page')
    onPageChange(value: number) {
      if (this.challenge?.id) {
        filesState.fetchAll({
          page: value,
          challengeId: this.challenge.id
        });
      }
    }
  }
